import { render, staticRenderFns } from "./ProfileComponent.vue?vue&type=template&id=72b9cc34"
import script from "./ProfileComponent.vue?vue&type=script&lang=js"
export * from "./ProfileComponent.vue?vue&type=script&lang=js"
import style0 from "./ProfileComponent.vue?vue&type=style&index=0&id=72b9cc34&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports